module.exports = __webpack_public_path__ + "static/media/trussardi-uomo.3bc2b38d.png";